import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import BreadCumb from "../../Component/BreadCumb";
import { toast } from "react-toastify";
import { nonNumericRegex } from "../../hooks/helper";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { updateCourse } from "../../Libs/api";
import { useLocation, useNavigate } from "react-router-dom";
import { MyContext } from "../../hooks/MyContextProvider";
import ImageUpload from "../../Component/ImageUpload";
import Select from "react-select";

const EditCourse = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setLoading } = useContext(MyContext);
  const [file, setFile] = useState(null);
  console.log("file: ", file);

  const [inputData, setInputData] = useState({
    title: location?.state?.name,
    description: location?.state?.description,
    aboutCourses: location?.state?.aboutCourses,
    keyFeatures: JSON.parse(location?.state?.keyFeatures || "[]"),
    courseObjective: location?.state?.courseObjective,
    otherDetails: location?.state?.otherDetails,
    durations: location?.state?.durations,
    syllabus: location?.state?.syllabus,
    skillLevel: location?.state?.skillLevel,
    class: location?.state?.class,
    groupSize: location?.state?.groupSize,
    status: location?.state?.status
      ? { label: "Active", value: true }
      : { label: "Inactive", value: false },
    softwareProvided: location?.state?.softwareProvided,
  });
  console.log("inputData: ", inputData);

  const [inputDataError, setInputDataError] = useState({
    title: false,
    description: false,
    aboutCourses: false,
    keyFeatures: false,
    courseObjective: false,
    otherDetails: false,
    durations: false,
    syllabus: false,
    skillLevel: false,
    class: false,
    groupSize: false,
    softwareProvided: false,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Sequential validation chain
    if (!inputData?.title) {
      toast.error("Please enter a title for the course");
      setInputDataError({ ...inputDataError, title: true });
    } else if (inputData.title.length < 3) {
      toast.error("Title must contain at least 3 characters");
      setInputDataError({ ...inputDataError, title: true });
    } else if (!inputData?.durations) {
      toast.error("Please specify the course duration");
      setInputDataError({ ...inputDataError, durations: true });
    } else if (inputData.durations.length < 3) {
      toast.error("Duration must contain at least 3 characters");
      setInputDataError({ ...inputDataError, durations: true });
    } else if (!inputData?.skillLevel) {
      toast.error("Please specify the skill level required");
      setInputDataError({ ...inputDataError, skillLevel: true });
    } else if (inputData.skillLevel.length < 3) {
      toast.error("Skill level must contain at least 3 characters");
      setInputDataError({ ...inputDataError, skillLevel: true });
    } else if (!inputData?.syllabus) {
      toast.error("Please provide course syllabus information");
      setInputDataError({ ...inputDataError, syllabus: true });
    } else if (inputData.syllabus.length < 3) {
      toast.error("Syllabus must contain at least 3 characters");
      setInputDataError({ ...inputDataError, syllabus: true });
    } else if (!inputData?.groupSize) {
      toast.error("Please specify the group size");
      setInputDataError({ ...inputDataError, groupSize: true });
    } else if (inputData.groupSize.length < 3) {
      toast.error("Group size must contain at least 3 characters");
      setInputDataError({ ...inputDataError, groupSize: true });
    } else if (!inputData?.softwareProvided) {
      toast.error("Please indicate if software is provided");
      setInputDataError({ ...inputDataError, softwareProvided: true });
    } else if (inputData.softwareProvided.length < 1) {
      toast.error("Please provide software information");
      setInputDataError({ ...inputDataError, softwareProvided: true });
    } else if (!inputData?.class) {
      toast.error("Please provide class information");
      setInputDataError({ ...inputDataError, class: true });
    } else if (inputData.class.length < 3) {
      toast.error("Class information must contain at least 3 characters");
      setInputDataError({ ...inputDataError, class: true });
    } else if (!inputData?.description) {
      toast.error("Please provide a course description");
      setInputDataError({ ...inputDataError, description: true });
    } else if (inputData.description.length < 3) {
      toast.error("Description must contain at least 3 characters");
      setInputDataError({ ...inputDataError, description: true });
    } else if (!inputData?.aboutCourses) {
      toast.error("Please provide information about the course");
      setInputDataError({ ...inputDataError, aboutCourses: true });
    } else if (inputData.aboutCourses.length < 3) {
      toast.error("Course information must contain at least 3 characters");
      setInputDataError({ ...inputDataError, aboutCourses: true });
    } else if (!inputData?.otherDetails) {
      toast.error("Please provide additional course details");
      setInputDataError({ ...inputDataError, otherDetails: true });
    } else if (inputData.otherDetails.length < 3) {
      toast.error("Additional details must contain at least 3 characters");
      setInputDataError({ ...inputDataError, otherDetails: true });
    } else if (!inputData?.courseObjective) {
      toast.error("Please provide course objective");
      setInputDataError({ ...inputDataError, courseObjective: true });
    } else if (inputData.courseObjective.length < 3) {
      toast.error("Course objective must contain at least 3 characters");
      setInputDataError({ ...inputDataError, courseObjective: true });
    } else if (
      !inputData?.keyFeatures ||
      !Array.isArray(inputData.keyFeatures)
    ) {
      toast.error("Please add at least one key feature");
      setInputDataError({ ...inputDataError, keyFeatures: true });
    } else if (inputData.keyFeatures.length < 1) {
      toast.error("Please add at least one key feature");
      setInputDataError({ ...inputDataError, keyFeatures: true });
    } else if (!file) {
      toast.error("Please upload a course image");
    } else {
      console.log("working");
      setLoading(true);

      let formData = new FormData();
      formData.append("name", inputData?.title);
      formData.append("description", inputData?.description);
      formData.append("aboutCourses", inputData?.aboutCourses);
      formData.append("keyFeatures", JSON.stringify(inputData?.keyFeatures));
      formData.append("courseObjective", inputData?.courseObjective);
      formData.append("otherDetails", inputData?.otherDetails);
      formData.append("durations", inputData?.durations);
      formData.append("syllabus", inputData?.syllabus);
      formData.append("skillLevel", inputData?.skillLevel);
      formData.append("class", inputData?.class);
      formData.append("groupSize", inputData?.groupSize);
      formData.append("softwareProvided", inputData?.softwareProvided);
      formData.append("status", inputData?.status?.value);

      formData.append("image", file);

      try {
        const apiCall = await updateCourse(formData, location?.state?.id);
        if (apiCall.status) {
          console.log(apiCall, "apiCall");
          toast.success("Record Updated Successfully");
          setLoading(false);
          navigate("/");
        } else {
          setLoading(false);

          toast.error(apiCall?.message);
        }
      } catch (error) {
        setLoading(false);
        console.log(error);
        toast.error(error);
      }
    }
  };

  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ align: [] }],
        ["link"],
        ["clean"],
      ],
      clipboard: {
        matchVisual: false, // Prevents Quill from creating additional divs on paste
      },
    }),
    []
  );

  useEffect(() => {
    if (location?.state?.images) {
      setFile({
        source: location?.state?.images,
        options: {
          type: "local",
        },
      });
    }
  }, [location?.state]);

  return (
    <div class="page-body">
      <BreadCumb title={"Add Course"} subtitle={"Course"} />
      <div class="container-fluid">
        <div class="edit-profile">
          <div class="row">
            <div class="col-xl-12">
              <form
                class="card"
                onSubmit={(e) => {
                  handleSubmit(e);
                }}
              >
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-5">
                      <div class="mb-3">
                        <label class="form-label">Title</label>
                        <input
                          class={`form-control ${
                            inputDataError?.title ? "border-danger" : ""
                          }`}
                          type="text"
                          placeholder="Enter Title.."
                          value={inputData?.title}
                          onChange={(e) => {
                            if (
                              nonNumericRegex.test(e.target.value) ||
                              e.target.value === ""
                            ) {
                              setInputData({
                                ...inputData,
                                title: e.target.value,
                              });

                              if (e.target.value?.length >= 3) {
                                setInputDataError({
                                  ...inputDataError,
                                  title: false,
                                });
                              } else {
                                setInputDataError({
                                  ...inputDataError,
                                  title: true,
                                });
                              }
                            } else {
                              toast.error("Type Characters Only", {
                                toastId: "sysmbol",
                              });
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div class="col-sm-6 col-md-3">
                      <div class="mb-3">
                        <label class="form-label">Durations</label>
                        <input
                          class={`form-control ${
                            inputDataError?.durations ? "border-danger" : ""
                          }`}
                          type="text"
                          placeholder="Enter Durations"
                          value={inputData?.durations}
                          onChange={(e) => {
                            setInputData({
                              ...inputData,
                              durations: e.target.value,
                            });

                            if (e.target.value?.length >= 3) {
                              setInputDataError({
                                ...inputDataError,
                                durations: false,
                              });
                            } else {
                              setInputDataError({
                                ...inputDataError,
                                durations: true,
                              });
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div class="col-sm-6 col-md-4">
                      <div class="mb-3">
                        <label class="form-label">Skill Level</label>
                        <input
                          class={`form-control ${
                            inputDataError?.skillLevel ? "border-danger" : ""
                          }`}
                          type="text"
                          placeholder="Enter Skill Level..."
                          value={inputData?.skillLevel}
                          onChange={(e) => {
                            if (
                              nonNumericRegex.test(e.target.value) ||
                              e.target.value === ""
                            ) {
                              setInputData({
                                ...inputData,
                                skillLevel: e.target.value,
                              });

                              if (e.target.value?.length >= 3) {
                                setInputDataError({
                                  ...inputDataError,
                                  skillLevel: false,
                                });
                              } else {
                                setInputDataError({
                                  ...inputDataError,
                                  skillLevel: true,
                                });
                              }
                            } else {
                              toast.error("Type Characters Only", {
                                toastId: "sysmbol",
                              });
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div class="col-sm-6 col-md-3">
                      <div class="mb-3">
                        <label class="form-label">Syllabus</label>
                        <input
                          class={`form-control ${
                            inputDataError?.syllabus ? "border-danger" : ""
                          }`}
                          type="text"
                          placeholder="Enter Syllabus..."
                          value={inputData?.syllabus}
                          onChange={(e) => {
                            if (
                              nonNumericRegex.test(e.target.value) ||
                              e.target.value === ""
                            ) {
                              setInputData({
                                ...inputData,
                                syllabus: e.target.value,
                              });

                              if (e.target.value?.length >= 3) {
                                setInputDataError({
                                  ...inputDataError,
                                  syllabus: false,
                                });
                              } else {
                                setInputDataError({
                                  ...inputDataError,
                                  syllabus: true,
                                });
                              }
                            } else {
                              toast.error("Type Characters Only", {
                                toastId: "sysmbol",
                              });
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div class="col-sm-6 col-md-3">
                      <div class="mb-3">
                        <label class="form-label">Group Size</label>
                        <input
                          class={`form-control ${
                            inputDataError?.groupSize ? "border-danger" : ""
                          }`}
                          type="text"
                          placeholder="Enter Group Size..."
                          value={inputData?.groupSize}
                          onChange={(e) => {
                            setInputData({
                              ...inputData,
                              groupSize: e.target.value,
                            });

                            if (e.target.value?.length >= 3) {
                              setInputDataError({
                                ...inputDataError,
                                groupSize: false,
                              });
                            } else {
                              setInputDataError({
                                ...inputDataError,
                                groupSize: true,
                              });
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div class="col-sm-6 col-md-3">
                      <div class="mb-3">
                        <label class="form-label">softwareProvided</label>
                        <select
                          value={inputData?.softwareProvided}
                          onChange={(e) => {
                            setInputData({
                              ...inputData,
                              softwareProvided: e.target.value,
                            });
                          }}
                          class={`form-control btn-square ${
                            inputDataError?.softwareProvided
                              ? "border-danger"
                              : ""
                          }`}
                        >
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-sm-6 col-md-3">
                      <div class="mb-3">
                        <label class="form-label">Class</label>
                        <input
                          class={`form-control ${
                            inputDataError?.class ? "border-danger" : ""
                          }`}
                          type="text"
                          placeholder="Enter Class..."
                          value={inputData?.class}
                          onChange={(e) => {
                            setInputData({
                              ...inputData,
                              class: e.target.value,
                            });

                            if (e.target.value?.length >= 3) {
                              setInputDataError({
                                ...inputDataError,
                                class: false,
                              });
                            } else {
                              setInputDataError({
                                ...inputDataError,
                                class: true,
                              });
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div class="col-sm-12 col-md-6">
                      <div class="mb-3">
                        <label class="form-label">Description</label>
                        <ReactQuill
                          theme="snow"
                          value={inputData?.description}
                          modules={modules}
                          onChange={(value) => {
                            setInputData({
                              ...inputData,
                              description: value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div class="mb-3">
                        <label class="form-label">About Course</label>
                        <ReactQuill
                          theme="snow"
                          value={inputData?.aboutCourses}
                          modules={modules}
                          onChange={(value) => {
                            setInputData({
                              ...inputData,
                              aboutCourses: value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div class="mb-3">
                        <label class="form-label">Other Details</label>
                        <ReactQuill
                          theme="snow"
                          modules={modules}
                          value={inputData?.otherDetails}
                          onChange={(value) => {
                            setInputData({
                              ...inputData,
                              otherDetails: value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div class="mb-3">
                        <label class="form-label">Course Objectives</label>
                        <ReactQuill
                          theme="snow"
                          value={inputData?.courseObjective}
                          modules={modules}
                          onChange={(value) => {
                            setInputData({
                              ...inputData,
                              courseObjective: value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-12">
                      <div class="mb-3">
                        <label class="form-label">Key Feature</label>
                        {inputData?.keyFeatures?.map((item, i) => (
                          <div
                            key={i}
                            className="col-md-12 d-flex justify-content-center align-items-center  mt-2"
                          >
                            <div className="col-md-10">
                              <input
                                class={`form-control ${
                                  inputDataError?.keyFeatures
                                    ? "border-danger"
                                    : ""
                                }`}
                                type="text"
                                placeholder="Enter Key Features..."
                                value={item}
                                onChange={(e) => {
                                  //  eslint-disable-next-line
                                  const arr = [...inputData?.keyFeatures];
                                  arr[i] = e.target.value;

                                  setInputData({
                                    ...inputData,
                                    keyFeatures: arr,
                                  });
                                }}
                              />
                            </div>
                            <div className="col-md-2 mx-2 d-flex justify-content-start  align-items-center  gap-2">
                              {" "}
                              <div className="">
                                <button
                                  type="button"
                                  onClick={() => {
                                    //  eslint-disable-next-line
                                    const arr = [...inputData?.keyFeatures];
                                    arr.push("");

                                    setInputData({
                                      ...inputData,
                                      keyFeatures: arr,
                                    });
                                  }}
                                  className="btn btn-primary px-3"
                                >
                                  <i class="fa fa-plus"></i>
                                </button>
                              </div>{" "}
                              {inputData?.keyFeatures?.length > 1 && (
                                <button
                                  type="button"
                                  onClick={() => {
                                    //  eslint-disable-next-line
                                    const arr = [...inputData?.keyFeatures];
                                    arr.splice(i, 1);
                                    setInputData({
                                      ...inputData,
                                      keyFeatures: arr,
                                    });
                                  }}
                                  className="btn btn-danger px-3"
                                >
                                  <i class="fa fa-minus"></i>
                                </button>
                              )}{" "}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-12">
                      <div class="mb-3">
                        <label class="form-label">Image</label>
                        <ImageUpload file={file} setFile={setFile} />
                      </div>
                    </div>

                    <div class="col-sm-4 col-md-4">
                      <div class="mb-3">
                        <label class="form-label">Status</label>
                        <Select
                          value={inputData?.status}
                          onChange={(e) => {
                            setInputData({
                              ...inputData,
                              status: e,
                            });
                          }}
                          class={`form-control btn-square ${
                            inputDataError?.status ? "border-danger" : ""
                          }`}
                          options={[
                            { value: true, label: "Active" },
                            { value: false, label: "Inactive" },
                          ]}
                        ></Select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer text-end">
                  <button class="btn btn-primary" type="submit">
                    Update Course
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCourse;
